/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AppRouteImport } from './routes/_app'
import { Route as LoginRouteImport } from './routes/login'
import { Route as SignupRouteImport } from './routes/signup'
import { Route as AppIndexRouteImport } from './routes/_app/index'
import { Route as AppAccountRouteImport } from './routes/_app/account'
import { Route as AppCalendarRouteImport } from './routes/_app/calendar'
import { Route as AppImportRouteImport } from './routes/_app/import'
import { Route as AppMoreRouteImport } from './routes/_app/more'
import { Route as AppSearchRouteImport } from './routes/_app/search'
import { Route as AppServicesRouteImport } from './routes/_app/services'
import { Route as AppSettingsRouteImport } from './routes/_app/settings'
import { Route as AppTeamRouteImport } from './routes/_app/team'
import { Route as AcceptInviteIdRouteImport } from './routes/accept-invite.$id'
import { Route as CalendarConnectTestRouteImport } from './routes/calendar-connect.test'
import { Route as ITokenRouteImport } from './routes/i.$token'
import { Route as QTokenRouteImport } from './routes/q.$token'
import { Route as AppCustomersIndexRouteImport } from './routes/_app/customers/index'
import { Route as AppCustomersIdRouteImport } from './routes/_app/customers/$id'
import { Route as AppDebugAvailabilityRouteImport } from './routes/_app/debug/availability'
import { Route as AppHelpIndexRouteImport } from './routes/_app/help/index'
import { Route as AppHelpIdRouteImport } from './routes/_app/help/$id'
import { Route as AppHelpWhatsNewRouteImport } from './routes/_app/help/whats-new'
import { Route as AppInvoicesIndexRouteImport } from './routes/_app/invoices/index'
import { Route as AppInvoicesIdRouteImport } from './routes/_app/invoices/$id'
import { Route as AppJobsIndexRouteImport } from './routes/_app/jobs/index'
import { Route as AppJobsIdRouteImport } from './routes/_app/jobs/$id'
import { Route as AppQuotesIndexRouteImport } from './routes/_app/quotes/index'
import { Route as AppQuotesIdRouteImport } from './routes/_app/quotes/$id'
import { Route as AppQuotesNewRouteImport } from './routes/_app/quotes/new'
import { Route as AppRequestsIndexRouteImport } from './routes/_app/requests/index'
import { Route as AppScheduleIndexRouteImport } from './routes/_app/schedule/index'
import { Route as AppScheduleIdRouteImport } from './routes/_app/schedule/$id'
import { Route as AppSettingsIndexRouteImport } from './routes/_app/settings/index'
import { Route as AppSettingsBookingRouteImport } from './routes/_app/settings/booking'
import { Route as AppSettingsClosuresRouteImport } from './routes/_app/settings/closures'
import { Route as AppSettingsDataRouteImport } from './routes/_app/settings/data'
import { Route as AppSettingsHoursRouteImport } from './routes/_app/settings/hours'
import { Route as AppSettingsInvoicingRouteImport } from './routes/_app/settings/invoicing'
import { Route as AppSettingsLocationsRouteImport } from './routes/_app/settings/locations'
import { Route as AppSettingsNotificationsRouteImport } from './routes/_app/settings/notifications'
import { Route as AppSettingsPaymentsRouteImport } from './routes/_app/settings/payments'
import { Route as AppSettingsPlanRouteImport } from './routes/_app/settings/plan'
import { Route as AppSettingsSchedulingRouteImport } from './routes/_app/settings/scheduling'
import { Route as PayTokenIndexRouteImport } from './routes/pay.$token.index'
import { Route as PayTokenTestCheckoutRouteImport } from './routes/pay.$token.test-checkout'

const AppRoute = AppRouteImport.update({
  id: '/_app',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const SignupRoute = SignupRouteImport.update({
  id: '/signup',
  path: '/signup',
  getParentRoute: () => rootRouteImport,
} as any)
const AppIndexRoute = AppIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppRoute,
} as any)
const AppAccountRoute = AppAccountRouteImport.update({
  id: '/account',
  path: '/account',
  getParentRoute: () => AppRoute,
} as any)
const AppCalendarRoute = AppCalendarRouteImport.update({
  id: '/calendar',
  path: '/calendar',
  getParentRoute: () => AppRoute,
} as any)
const AppImportRoute = AppImportRouteImport.update({
  id: '/import',
  path: '/import',
  getParentRoute: () => AppRoute,
} as any)
const AppMoreRoute = AppMoreRouteImport.update({
  id: '/more',
  path: '/more',
  getParentRoute: () => AppRoute,
} as any)
const AppSearchRoute = AppSearchRouteImport.update({
  id: '/search',
  path: '/search',
  getParentRoute: () => AppRoute,
} as any)
const AppServicesRoute = AppServicesRouteImport.update({
  id: '/services',
  path: '/services',
  getParentRoute: () => AppRoute,
} as any)
const AppSettingsRoute = AppSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AppRoute,
} as any)
const AppTeamRoute = AppTeamRouteImport.update({
  id: '/team',
  path: '/team',
  getParentRoute: () => AppRoute,
} as any)
const AcceptInviteIdRoute = AcceptInviteIdRouteImport.update({
  id: '/accept-invite/$id',
  path: '/accept-invite/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const CalendarConnectTestRoute = CalendarConnectTestRouteImport.update({
  id: '/calendar-connect/test',
  path: '/calendar-connect/test',
  getParentRoute: () => rootRouteImport,
} as any)
const ITokenRoute = ITokenRouteImport.update({
  id: '/i/$token',
  path: '/i/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const QTokenRoute = QTokenRouteImport.update({
  id: '/q/$token',
  path: '/q/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const AppCustomersIndexRoute = AppCustomersIndexRouteImport.update({
  id: '/customers/',
  path: '/customers/',
  getParentRoute: () => AppRoute,
} as any)
const AppCustomersIdRoute = AppCustomersIdRouteImport.update({
  id: '/customers/$id',
  path: '/customers/$id',
  getParentRoute: () => AppRoute,
} as any)
const AppDebugAvailabilityRoute = AppDebugAvailabilityRouteImport.update({
  id: '/debug/availability',
  path: '/debug/availability',
  getParentRoute: () => AppRoute,
} as any)
const AppHelpIndexRoute = AppHelpIndexRouteImport.update({
  id: '/help/',
  path: '/help/',
  getParentRoute: () => AppRoute,
} as any)
const AppHelpIdRoute = AppHelpIdRouteImport.update({
  id: '/help/$id',
  path: '/help/$id',
  getParentRoute: () => AppRoute,
} as any)
const AppHelpWhatsNewRoute = AppHelpWhatsNewRouteImport.update({
  id: '/help/whats-new',
  path: '/help/whats-new',
  getParentRoute: () => AppRoute,
} as any)
const AppInvoicesIndexRoute = AppInvoicesIndexRouteImport.update({
  id: '/invoices/',
  path: '/invoices/',
  getParentRoute: () => AppRoute,
} as any)
const AppInvoicesIdRoute = AppInvoicesIdRouteImport.update({
  id: '/invoices/$id',
  path: '/invoices/$id',
  getParentRoute: () => AppRoute,
} as any)
const AppJobsIndexRoute = AppJobsIndexRouteImport.update({
  id: '/jobs/',
  path: '/jobs/',
  getParentRoute: () => AppRoute,
} as any)
const AppJobsIdRoute = AppJobsIdRouteImport.update({
  id: '/jobs/$id',
  path: '/jobs/$id',
  getParentRoute: () => AppRoute,
} as any)
const AppQuotesIndexRoute = AppQuotesIndexRouteImport.update({
  id: '/quotes/',
  path: '/quotes/',
  getParentRoute: () => AppRoute,
} as any)
const AppQuotesIdRoute = AppQuotesIdRouteImport.update({
  id: '/quotes/$id',
  path: '/quotes/$id',
  getParentRoute: () => AppRoute,
} as any)
const AppQuotesNewRoute = AppQuotesNewRouteImport.update({
  id: '/quotes/new',
  path: '/quotes/new',
  getParentRoute: () => AppRoute,
} as any)
const AppRequestsIndexRoute = AppRequestsIndexRouteImport.update({
  id: '/requests/',
  path: '/requests/',
  getParentRoute: () => AppRoute,
} as any)
const AppScheduleIndexRoute = AppScheduleIndexRouteImport.update({
  id: '/schedule/',
  path: '/schedule/',
  getParentRoute: () => AppRoute,
} as any)
const AppScheduleIdRoute = AppScheduleIdRouteImport.update({
  id: '/schedule/$id',
  path: '/schedule/$id',
  getParentRoute: () => AppRoute,
} as any)
const AppSettingsIndexRoute = AppSettingsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppSettingsRoute,
} as any)
const AppSettingsBookingRoute = AppSettingsBookingRouteImport.update({
  id: '/booking',
  path: '/booking',
  getParentRoute: () => AppSettingsRoute,
} as any)
const AppSettingsClosuresRoute = AppSettingsClosuresRouteImport.update({
  id: '/closures',
  path: '/closures',
  getParentRoute: () => AppSettingsRoute,
} as any)
const AppSettingsDataRoute = AppSettingsDataRouteImport.update({
  id: '/data',
  path: '/data',
  getParentRoute: () => AppSettingsRoute,
} as any)
const AppSettingsHoursRoute = AppSettingsHoursRouteImport.update({
  id: '/hours',
  path: '/hours',
  getParentRoute: () => AppSettingsRoute,
} as any)
const AppSettingsInvoicingRoute = AppSettingsInvoicingRouteImport.update({
  id: '/invoicing',
  path: '/invoicing',
  getParentRoute: () => AppSettingsRoute,
} as any)
const AppSettingsLocationsRoute = AppSettingsLocationsRouteImport.update({
  id: '/locations',
  path: '/locations',
  getParentRoute: () => AppSettingsRoute,
} as any)
const AppSettingsNotificationsRoute =
  AppSettingsNotificationsRouteImport.update({
    id: '/notifications',
    path: '/notifications',
    getParentRoute: () => AppSettingsRoute,
  } as any)
const AppSettingsPaymentsRoute = AppSettingsPaymentsRouteImport.update({
  id: '/payments',
  path: '/payments',
  getParentRoute: () => AppSettingsRoute,
} as any)
const AppSettingsPlanRoute = AppSettingsPlanRouteImport.update({
  id: '/plan',
  path: '/plan',
  getParentRoute: () => AppSettingsRoute,
} as any)
const AppSettingsSchedulingRoute = AppSettingsSchedulingRouteImport.update({
  id: '/scheduling',
  path: '/scheduling',
  getParentRoute: () => AppSettingsRoute,
} as any)
const PayTokenIndexRoute = PayTokenIndexRouteImport.update({
  id: '/pay/$token/',
  path: '/pay/$token/',
  getParentRoute: () => rootRouteImport,
} as any)
const PayTokenTestCheckoutRoute = PayTokenTestCheckoutRouteImport.update({
  id: '/pay/$token/test-checkout',
  path: '/pay/$token/test-checkout',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof AppIndexRoute
  '/login': typeof LoginRoute
  '/signup': typeof SignupRoute
  '/account': typeof AppAccountRoute
  '/calendar': typeof AppCalendarRoute
  '/import': typeof AppImportRoute
  '/more': typeof AppMoreRoute
  '/search': typeof AppSearchRoute
  '/services': typeof AppServicesRoute
  '/settings': typeof AppSettingsRouteWithChildren
  '/team': typeof AppTeamRoute
  '/accept-invite/$id': typeof AcceptInviteIdRoute
  '/calendar-connect/test': typeof CalendarConnectTestRoute
  '/i/$token': typeof ITokenRoute
  '/q/$token': typeof QTokenRoute
  '/customers/$id': typeof AppCustomersIdRoute
  '/debug/availability': typeof AppDebugAvailabilityRoute
  '/help/$id': typeof AppHelpIdRoute
  '/help/whats-new': typeof AppHelpWhatsNewRoute
  '/invoices/$id': typeof AppInvoicesIdRoute
  '/jobs/$id': typeof AppJobsIdRoute
  '/quotes/$id': typeof AppQuotesIdRoute
  '/quotes/new': typeof AppQuotesNewRoute
  '/schedule/$id': typeof AppScheduleIdRoute
  '/settings/booking': typeof AppSettingsBookingRoute
  '/settings/closures': typeof AppSettingsClosuresRoute
  '/settings/data': typeof AppSettingsDataRoute
  '/settings/hours': typeof AppSettingsHoursRoute
  '/settings/invoicing': typeof AppSettingsInvoicingRoute
  '/settings/locations': typeof AppSettingsLocationsRoute
  '/settings/notifications': typeof AppSettingsNotificationsRoute
  '/settings/payments': typeof AppSettingsPaymentsRoute
  '/settings/plan': typeof AppSettingsPlanRoute
  '/settings/scheduling': typeof AppSettingsSchedulingRoute
  '/pay/$token/test-checkout': typeof PayTokenTestCheckoutRoute
  '/customers/': typeof AppCustomersIndexRoute
  '/help/': typeof AppHelpIndexRoute
  '/invoices/': typeof AppInvoicesIndexRoute
  '/jobs/': typeof AppJobsIndexRoute
  '/quotes/': typeof AppQuotesIndexRoute
  '/requests/': typeof AppRequestsIndexRoute
  '/schedule/': typeof AppScheduleIndexRoute
  '/settings/': typeof AppSettingsIndexRoute
  '/pay/$token/': typeof PayTokenIndexRoute
}
export interface FileRoutesByTo {
  '/login': typeof LoginRoute
  '/signup': typeof SignupRoute
  '/account': typeof AppAccountRoute
  '/calendar': typeof AppCalendarRoute
  '/import': typeof AppImportRoute
  '/more': typeof AppMoreRoute
  '/search': typeof AppSearchRoute
  '/services': typeof AppServicesRoute
  '/team': typeof AppTeamRoute
  '/accept-invite/$id': typeof AcceptInviteIdRoute
  '/calendar-connect/test': typeof CalendarConnectTestRoute
  '/i/$token': typeof ITokenRoute
  '/q/$token': typeof QTokenRoute
  '/': typeof AppIndexRoute
  '/customers/$id': typeof AppCustomersIdRoute
  '/debug/availability': typeof AppDebugAvailabilityRoute
  '/help/$id': typeof AppHelpIdRoute
  '/help/whats-new': typeof AppHelpWhatsNewRoute
  '/invoices/$id': typeof AppInvoicesIdRoute
  '/jobs/$id': typeof AppJobsIdRoute
  '/quotes/$id': typeof AppQuotesIdRoute
  '/quotes/new': typeof AppQuotesNewRoute
  '/schedule/$id': typeof AppScheduleIdRoute
  '/settings/booking': typeof AppSettingsBookingRoute
  '/settings/closures': typeof AppSettingsClosuresRoute
  '/settings/data': typeof AppSettingsDataRoute
  '/settings/hours': typeof AppSettingsHoursRoute
  '/settings/invoicing': typeof AppSettingsInvoicingRoute
  '/settings/locations': typeof AppSettingsLocationsRoute
  '/settings/notifications': typeof AppSettingsNotificationsRoute
  '/settings/payments': typeof AppSettingsPaymentsRoute
  '/settings/plan': typeof AppSettingsPlanRoute
  '/settings/scheduling': typeof AppSettingsSchedulingRoute
  '/pay/$token/test-checkout': typeof PayTokenTestCheckoutRoute
  '/customers': typeof AppCustomersIndexRoute
  '/help': typeof AppHelpIndexRoute
  '/invoices': typeof AppInvoicesIndexRoute
  '/jobs': typeof AppJobsIndexRoute
  '/quotes': typeof AppQuotesIndexRoute
  '/requests': typeof AppRequestsIndexRoute
  '/schedule': typeof AppScheduleIndexRoute
  '/settings': typeof AppSettingsIndexRoute
  '/pay/$token': typeof PayTokenIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_app': typeof AppRouteWithChildren
  '/login': typeof LoginRoute
  '/signup': typeof SignupRoute
  '/_app/account': typeof AppAccountRoute
  '/_app/calendar': typeof AppCalendarRoute
  '/_app/import': typeof AppImportRoute
  '/_app/more': typeof AppMoreRoute
  '/_app/search': typeof AppSearchRoute
  '/_app/services': typeof AppServicesRoute
  '/_app/settings': typeof AppSettingsRouteWithChildren
  '/_app/team': typeof AppTeamRoute
  '/accept-invite/$id': typeof AcceptInviteIdRoute
  '/calendar-connect/test': typeof CalendarConnectTestRoute
  '/i/$token': typeof ITokenRoute
  '/q/$token': typeof QTokenRoute
  '/_app/': typeof AppIndexRoute
  '/_app/customers/$id': typeof AppCustomersIdRoute
  '/_app/debug/availability': typeof AppDebugAvailabilityRoute
  '/_app/help/$id': typeof AppHelpIdRoute
  '/_app/help/whats-new': typeof AppHelpWhatsNewRoute
  '/_app/invoices/$id': typeof AppInvoicesIdRoute
  '/_app/jobs/$id': typeof AppJobsIdRoute
  '/_app/quotes/$id': typeof AppQuotesIdRoute
  '/_app/quotes/new': typeof AppQuotesNewRoute
  '/_app/schedule/$id': typeof AppScheduleIdRoute
  '/_app/settings/booking': typeof AppSettingsBookingRoute
  '/_app/settings/closures': typeof AppSettingsClosuresRoute
  '/_app/settings/data': typeof AppSettingsDataRoute
  '/_app/settings/hours': typeof AppSettingsHoursRoute
  '/_app/settings/invoicing': typeof AppSettingsInvoicingRoute
  '/_app/settings/locations': typeof AppSettingsLocationsRoute
  '/_app/settings/notifications': typeof AppSettingsNotificationsRoute
  '/_app/settings/payments': typeof AppSettingsPaymentsRoute
  '/_app/settings/plan': typeof AppSettingsPlanRoute
  '/_app/settings/scheduling': typeof AppSettingsSchedulingRoute
  '/pay/$token/test-checkout': typeof PayTokenTestCheckoutRoute
  '/_app/customers/': typeof AppCustomersIndexRoute
  '/_app/help/': typeof AppHelpIndexRoute
  '/_app/invoices/': typeof AppInvoicesIndexRoute
  '/_app/jobs/': typeof AppJobsIndexRoute
  '/_app/quotes/': typeof AppQuotesIndexRoute
  '/_app/requests/': typeof AppRequestsIndexRoute
  '/_app/schedule/': typeof AppScheduleIndexRoute
  '/_app/settings/': typeof AppSettingsIndexRoute
  '/pay/$token/': typeof PayTokenIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/login'
    | '/signup'
    | '/account'
    | '/calendar'
    | '/import'
    | '/more'
    | '/search'
    | '/services'
    | '/settings'
    | '/team'
    | '/accept-invite/$id'
    | '/calendar-connect/test'
    | '/i/$token'
    | '/q/$token'
    | '/customers/$id'
    | '/debug/availability'
    | '/help/$id'
    | '/help/whats-new'
    | '/invoices/$id'
    | '/jobs/$id'
    | '/quotes/$id'
    | '/quotes/new'
    | '/schedule/$id'
    | '/settings/booking'
    | '/settings/closures'
    | '/settings/data'
    | '/settings/hours'
    | '/settings/invoicing'
    | '/settings/locations'
    | '/settings/notifications'
    | '/settings/payments'
    | '/settings/plan'
    | '/settings/scheduling'
    | '/pay/$token/test-checkout'
    | '/customers/'
    | '/help/'
    | '/invoices/'
    | '/jobs/'
    | '/quotes/'
    | '/requests/'
    | '/schedule/'
    | '/settings/'
    | '/pay/$token/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/login'
    | '/signup'
    | '/account'
    | '/calendar'
    | '/import'
    | '/more'
    | '/search'
    | '/services'
    | '/team'
    | '/accept-invite/$id'
    | '/calendar-connect/test'
    | '/i/$token'
    | '/q/$token'
    | '/'
    | '/customers/$id'
    | '/debug/availability'
    | '/help/$id'
    | '/help/whats-new'
    | '/invoices/$id'
    | '/jobs/$id'
    | '/quotes/$id'
    | '/quotes/new'
    | '/schedule/$id'
    | '/settings/booking'
    | '/settings/closures'
    | '/settings/data'
    | '/settings/hours'
    | '/settings/invoicing'
    | '/settings/locations'
    | '/settings/notifications'
    | '/settings/payments'
    | '/settings/plan'
    | '/settings/scheduling'
    | '/pay/$token/test-checkout'
    | '/customers'
    | '/help'
    | '/invoices'
    | '/jobs'
    | '/quotes'
    | '/requests'
    | '/schedule'
    | '/settings'
    | '/pay/$token'
  id:
    | '__root__'
    | '/_app'
    | '/login'
    | '/signup'
    | '/_app/account'
    | '/_app/calendar'
    | '/_app/import'
    | '/_app/more'
    | '/_app/search'
    | '/_app/services'
    | '/_app/settings'
    | '/_app/team'
    | '/accept-invite/$id'
    | '/calendar-connect/test'
    | '/i/$token'
    | '/q/$token'
    | '/_app/'
    | '/_app/customers/$id'
    | '/_app/debug/availability'
    | '/_app/help/$id'
    | '/_app/help/whats-new'
    | '/_app/invoices/$id'
    | '/_app/jobs/$id'
    | '/_app/quotes/$id'
    | '/_app/quotes/new'
    | '/_app/schedule/$id'
    | '/_app/settings/booking'
    | '/_app/settings/closures'
    | '/_app/settings/data'
    | '/_app/settings/hours'
    | '/_app/settings/invoicing'
    | '/_app/settings/locations'
    | '/_app/settings/notifications'
    | '/_app/settings/payments'
    | '/_app/settings/plan'
    | '/_app/settings/scheduling'
    | '/pay/$token/test-checkout'
    | '/_app/customers/'
    | '/_app/help/'
    | '/_app/invoices/'
    | '/_app/jobs/'
    | '/_app/quotes/'
    | '/_app/requests/'
    | '/_app/schedule/'
    | '/_app/settings/'
    | '/pay/$token/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AppRoute: typeof AppRouteWithChildren
  LoginRoute: typeof LoginRoute
  SignupRoute: typeof SignupRoute
  AcceptInviteIdRoute: typeof AcceptInviteIdRoute
  CalendarConnectTestRoute: typeof CalendarConnectTestRoute
  ITokenRoute: typeof ITokenRoute
  QTokenRoute: typeof QTokenRoute
  PayTokenTestCheckoutRoute: typeof PayTokenTestCheckoutRoute
  PayTokenIndexRoute: typeof PayTokenIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/signup': {
      id: '/signup'
      path: '/signup'
      fullPath: '/signup'
      preLoaderRoute: typeof SignupRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/': {
      id: '/_app/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AppIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/account': {
      id: '/_app/account'
      path: '/account'
      fullPath: '/account'
      preLoaderRoute: typeof AppAccountRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/calendar': {
      id: '/_app/calendar'
      path: '/calendar'
      fullPath: '/calendar'
      preLoaderRoute: typeof AppCalendarRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/import': {
      id: '/_app/import'
      path: '/import'
      fullPath: '/import'
      preLoaderRoute: typeof AppImportRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/more': {
      id: '/_app/more'
      path: '/more'
      fullPath: '/more'
      preLoaderRoute: typeof AppMoreRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/search': {
      id: '/_app/search'
      path: '/search'
      fullPath: '/search'
      preLoaderRoute: typeof AppSearchRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/services': {
      id: '/_app/services'
      path: '/services'
      fullPath: '/services'
      preLoaderRoute: typeof AppServicesRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/settings': {
      id: '/_app/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof AppSettingsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/team': {
      id: '/_app/team'
      path: '/team'
      fullPath: '/team'
      preLoaderRoute: typeof AppTeamRouteImport
      parentRoute: typeof AppRoute
    }
    '/accept-invite/$id': {
      id: '/accept-invite/$id'
      path: '/accept-invite/$id'
      fullPath: '/accept-invite/$id'
      preLoaderRoute: typeof AcceptInviteIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/calendar-connect/test': {
      id: '/calendar-connect/test'
      path: '/calendar-connect/test'
      fullPath: '/calendar-connect/test'
      preLoaderRoute: typeof CalendarConnectTestRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/i/$token': {
      id: '/i/$token'
      path: '/i/$token'
      fullPath: '/i/$token'
      preLoaderRoute: typeof ITokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/q/$token': {
      id: '/q/$token'
      path: '/q/$token'
      fullPath: '/q/$token'
      preLoaderRoute: typeof QTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/customers/': {
      id: '/_app/customers/'
      path: '/customers'
      fullPath: '/customers/'
      preLoaderRoute: typeof AppCustomersIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/customers/$id': {
      id: '/_app/customers/$id'
      path: '/customers/$id'
      fullPath: '/customers/$id'
      preLoaderRoute: typeof AppCustomersIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/debug/availability': {
      id: '/_app/debug/availability'
      path: '/debug/availability'
      fullPath: '/debug/availability'
      preLoaderRoute: typeof AppDebugAvailabilityRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/help/': {
      id: '/_app/help/'
      path: '/help'
      fullPath: '/help/'
      preLoaderRoute: typeof AppHelpIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/help/$id': {
      id: '/_app/help/$id'
      path: '/help/$id'
      fullPath: '/help/$id'
      preLoaderRoute: typeof AppHelpIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/help/whats-new': {
      id: '/_app/help/whats-new'
      path: '/help/whats-new'
      fullPath: '/help/whats-new'
      preLoaderRoute: typeof AppHelpWhatsNewRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/invoices/': {
      id: '/_app/invoices/'
      path: '/invoices'
      fullPath: '/invoices/'
      preLoaderRoute: typeof AppInvoicesIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/invoices/$id': {
      id: '/_app/invoices/$id'
      path: '/invoices/$id'
      fullPath: '/invoices/$id'
      preLoaderRoute: typeof AppInvoicesIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/jobs/': {
      id: '/_app/jobs/'
      path: '/jobs'
      fullPath: '/jobs/'
      preLoaderRoute: typeof AppJobsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/jobs/$id': {
      id: '/_app/jobs/$id'
      path: '/jobs/$id'
      fullPath: '/jobs/$id'
      preLoaderRoute: typeof AppJobsIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/quotes/': {
      id: '/_app/quotes/'
      path: '/quotes'
      fullPath: '/quotes/'
      preLoaderRoute: typeof AppQuotesIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/quotes/$id': {
      id: '/_app/quotes/$id'
      path: '/quotes/$id'
      fullPath: '/quotes/$id'
      preLoaderRoute: typeof AppQuotesIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/quotes/new': {
      id: '/_app/quotes/new'
      path: '/quotes/new'
      fullPath: '/quotes/new'
      preLoaderRoute: typeof AppQuotesNewRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/requests/': {
      id: '/_app/requests/'
      path: '/requests'
      fullPath: '/requests/'
      preLoaderRoute: typeof AppRequestsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/schedule/': {
      id: '/_app/schedule/'
      path: '/schedule'
      fullPath: '/schedule/'
      preLoaderRoute: typeof AppScheduleIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/schedule/$id': {
      id: '/_app/schedule/$id'
      path: '/schedule/$id'
      fullPath: '/schedule/$id'
      preLoaderRoute: typeof AppScheduleIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/settings/': {
      id: '/_app/settings/'
      path: '/'
      fullPath: '/settings/'
      preLoaderRoute: typeof AppSettingsIndexRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/_app/settings/booking': {
      id: '/_app/settings/booking'
      path: '/booking'
      fullPath: '/settings/booking'
      preLoaderRoute: typeof AppSettingsBookingRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/_app/settings/closures': {
      id: '/_app/settings/closures'
      path: '/closures'
      fullPath: '/settings/closures'
      preLoaderRoute: typeof AppSettingsClosuresRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/_app/settings/data': {
      id: '/_app/settings/data'
      path: '/data'
      fullPath: '/settings/data'
      preLoaderRoute: typeof AppSettingsDataRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/_app/settings/hours': {
      id: '/_app/settings/hours'
      path: '/hours'
      fullPath: '/settings/hours'
      preLoaderRoute: typeof AppSettingsHoursRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/_app/settings/invoicing': {
      id: '/_app/settings/invoicing'
      path: '/invoicing'
      fullPath: '/settings/invoicing'
      preLoaderRoute: typeof AppSettingsInvoicingRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/_app/settings/locations': {
      id: '/_app/settings/locations'
      path: '/locations'
      fullPath: '/settings/locations'
      preLoaderRoute: typeof AppSettingsLocationsRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/_app/settings/notifications': {
      id: '/_app/settings/notifications'
      path: '/notifications'
      fullPath: '/settings/notifications'
      preLoaderRoute: typeof AppSettingsNotificationsRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/_app/settings/payments': {
      id: '/_app/settings/payments'
      path: '/payments'
      fullPath: '/settings/payments'
      preLoaderRoute: typeof AppSettingsPaymentsRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/_app/settings/plan': {
      id: '/_app/settings/plan'
      path: '/plan'
      fullPath: '/settings/plan'
      preLoaderRoute: typeof AppSettingsPlanRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/_app/settings/scheduling': {
      id: '/_app/settings/scheduling'
      path: '/scheduling'
      fullPath: '/settings/scheduling'
      preLoaderRoute: typeof AppSettingsSchedulingRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/pay/$token/': {
      id: '/pay/$token/'
      path: '/pay/$token'
      fullPath: '/pay/$token/'
      preLoaderRoute: typeof PayTokenIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/pay/$token/test-checkout': {
      id: '/pay/$token/test-checkout'
      path: '/pay/$token/test-checkout'
      fullPath: '/pay/$token/test-checkout'
      preLoaderRoute: typeof PayTokenTestCheckoutRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

interface AppSettingsRouteChildren {
  AppSettingsBookingRoute: typeof AppSettingsBookingRoute
  AppSettingsClosuresRoute: typeof AppSettingsClosuresRoute
  AppSettingsDataRoute: typeof AppSettingsDataRoute
  AppSettingsHoursRoute: typeof AppSettingsHoursRoute
  AppSettingsInvoicingRoute: typeof AppSettingsInvoicingRoute
  AppSettingsLocationsRoute: typeof AppSettingsLocationsRoute
  AppSettingsNotificationsRoute: typeof AppSettingsNotificationsRoute
  AppSettingsPaymentsRoute: typeof AppSettingsPaymentsRoute
  AppSettingsPlanRoute: typeof AppSettingsPlanRoute
  AppSettingsSchedulingRoute: typeof AppSettingsSchedulingRoute
  AppSettingsIndexRoute: typeof AppSettingsIndexRoute
}

const AppSettingsRouteChildren: AppSettingsRouteChildren = {
  AppSettingsBookingRoute: AppSettingsBookingRoute,
  AppSettingsClosuresRoute: AppSettingsClosuresRoute,
  AppSettingsDataRoute: AppSettingsDataRoute,
  AppSettingsHoursRoute: AppSettingsHoursRoute,
  AppSettingsInvoicingRoute: AppSettingsInvoicingRoute,
  AppSettingsLocationsRoute: AppSettingsLocationsRoute,
  AppSettingsNotificationsRoute: AppSettingsNotificationsRoute,
  AppSettingsPaymentsRoute: AppSettingsPaymentsRoute,
  AppSettingsPlanRoute: AppSettingsPlanRoute,
  AppSettingsSchedulingRoute: AppSettingsSchedulingRoute,
  AppSettingsIndexRoute: AppSettingsIndexRoute,
}

const AppSettingsRouteWithChildren = AppSettingsRoute._addFileChildren(
  AppSettingsRouteChildren,
)

interface AppRouteChildren {
  AppAccountRoute: typeof AppAccountRoute
  AppCalendarRoute: typeof AppCalendarRoute
  AppImportRoute: typeof AppImportRoute
  AppMoreRoute: typeof AppMoreRoute
  AppSearchRoute: typeof AppSearchRoute
  AppServicesRoute: typeof AppServicesRoute
  AppSettingsRoute: typeof AppSettingsRouteWithChildren
  AppTeamRoute: typeof AppTeamRoute
  AppIndexRoute: typeof AppIndexRoute
  AppCustomersIdRoute: typeof AppCustomersIdRoute
  AppDebugAvailabilityRoute: typeof AppDebugAvailabilityRoute
  AppHelpIdRoute: typeof AppHelpIdRoute
  AppHelpWhatsNewRoute: typeof AppHelpWhatsNewRoute
  AppInvoicesIdRoute: typeof AppInvoicesIdRoute
  AppJobsIdRoute: typeof AppJobsIdRoute
  AppQuotesIdRoute: typeof AppQuotesIdRoute
  AppQuotesNewRoute: typeof AppQuotesNewRoute
  AppScheduleIdRoute: typeof AppScheduleIdRoute
  AppCustomersIndexRoute: typeof AppCustomersIndexRoute
  AppHelpIndexRoute: typeof AppHelpIndexRoute
  AppInvoicesIndexRoute: typeof AppInvoicesIndexRoute
  AppJobsIndexRoute: typeof AppJobsIndexRoute
  AppQuotesIndexRoute: typeof AppQuotesIndexRoute
  AppRequestsIndexRoute: typeof AppRequestsIndexRoute
  AppScheduleIndexRoute: typeof AppScheduleIndexRoute
}

const AppRouteChildren: AppRouteChildren = {
  AppAccountRoute: AppAccountRoute,
  AppCalendarRoute: AppCalendarRoute,
  AppImportRoute: AppImportRoute,
  AppMoreRoute: AppMoreRoute,
  AppSearchRoute: AppSearchRoute,
  AppServicesRoute: AppServicesRoute,
  AppSettingsRoute: AppSettingsRouteWithChildren,
  AppTeamRoute: AppTeamRoute,
  AppIndexRoute: AppIndexRoute,
  AppCustomersIdRoute: AppCustomersIdRoute,
  AppDebugAvailabilityRoute: AppDebugAvailabilityRoute,
  AppHelpIdRoute: AppHelpIdRoute,
  AppHelpWhatsNewRoute: AppHelpWhatsNewRoute,
  AppInvoicesIdRoute: AppInvoicesIdRoute,
  AppJobsIdRoute: AppJobsIdRoute,
  AppQuotesIdRoute: AppQuotesIdRoute,
  AppQuotesNewRoute: AppQuotesNewRoute,
  AppScheduleIdRoute: AppScheduleIdRoute,
  AppCustomersIndexRoute: AppCustomersIndexRoute,
  AppHelpIndexRoute: AppHelpIndexRoute,
  AppInvoicesIndexRoute: AppInvoicesIndexRoute,
  AppJobsIndexRoute: AppJobsIndexRoute,
  AppQuotesIndexRoute: AppQuotesIndexRoute,
  AppRequestsIndexRoute: AppRequestsIndexRoute,
  AppScheduleIndexRoute: AppScheduleIndexRoute,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AppRoute: AppRouteWithChildren,
  LoginRoute: LoginRoute,
  SignupRoute: SignupRoute,
  AcceptInviteIdRoute: AcceptInviteIdRoute,
  CalendarConnectTestRoute: CalendarConnectTestRoute,
  ITokenRoute: ITokenRoute,
  QTokenRoute: QTokenRoute,
  PayTokenTestCheckoutRoute: PayTokenTestCheckoutRoute,
  PayTokenIndexRoute: PayTokenIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
